import { makeStyles } from "@material-ui/core";

export const quickWinsPupopStyles = makeStyles((theme) => ({
  container: {
    background: "#FFFFFF",
    borderRadius: "10px",
    maxWidth: "220px",
    padding: "0px 15px 15px 15px",
    position: "relative",
    opacity: "0.9",
  },
  header: {
    "& svg": {
      fill: "black",
    },
  },
  closeContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    "& .MuiButtonBase-root": {
      backgroundColor: "transparent",
      width: "20px",
      minWidth: "20px",
      padding: "5px 0px 5px 0px",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  },
  title: {
    fontFamily: "Lato",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(18),
    marginBottom: "10px",
  },
  numQuickWins: {
    color: "#45547C",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    marginBottom: "10px",
  },
  quickWin: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    padding: "5px 0px 5px 0px",
  },
  checkedIcon: {
    marginRight: "7px",
  },
  footer: {
    "& div": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "10px",
    },
    marginTop: "10px",
    "& svg path": {
      fill: "#22D9BB",
    },
  },
  triangle: {
    width: "0px",
    height: "0px",
    border: "10px solid",
    borderTopColor: "transparent",
    borderLeftColor: "transparent",
    borderRightColor: "#FFFFFF",
    borderBottomColor: "transparent",
    position: "absolute",
    left: "-17px",
    top: "22%",
    opacity: "0.9",
  },
}));
